(function () {
  'use strict';
  if (window.__avSiteNavigation) return;
  window.__avSiteNavigation = true;
  const selector = '.av-mobile-menu';
  const mobile = window.matchMedia('(max-width: 1150px)');
  function update(menu) {
    const summary = menu.querySelector('summary');
    if (!summary) return;
    const labels = document.querySelector('[data-av-refinement-labels]');
    summary.setAttribute('aria-expanded', String(menu.open));
    if (labels) {
      const text = menu.open ? labels.dataset.closeMenu : labels.dataset.openMenu;
      if (text) summary.setAttribute('aria-label', text);
    }
  }
  function close(menu) {
    menu.open = false;
    update(menu);
  }
  function init() {
    document.querySelectorAll(selector).forEach(update);
    document.querySelectorAll('.av-global-header nav a[href]').forEach(function (link) {
      if (link.hasAttribute('data-av-current-page')) {
        link.removeAttribute('aria-current');
        link.removeAttribute('data-av-current-page');
      }
      if (link.hasAttribute('aria-current')) return;
      try {
        const url = new URL(link.href, window.location.href);
        if (!url.hash && url.origin === window.location.origin && url.pathname === window.location.pathname) {
          link.setAttribute('aria-current', 'page');
          link.setAttribute('data-av-current-page', '');
        }
      } catch (_) {}
    });
  }
  document.addEventListener('toggle', function (event) {
    if (event.target instanceof Element && event.target.matches(selector)) update(event.target);
  }, true);
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll(selector + '[open]').forEach(function (menu) {
      if (!menu.contains(event.target) || event.target.closest('a[href]')) close(menu);
    });
  });
  document.addEventListener('focusout', function (event) {
    if (!(event.target instanceof Element)) return;
    const menu = event.target.closest(selector);
    if (!menu || !menu.open) return;
    if (event.relatedTarget instanceof Node && menu.contains(event.relatedTarget)) return;
    window.setTimeout(function () {
      if (menu.isConnected && !menu.contains(document.activeElement)) close(menu);
    }, 0);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || event.defaultPrevented || !(event.target instanceof Element)) return;
    const menu = event.target.closest(selector + '[open]');
    if (!menu) return;
    close(menu);
    const summary = menu.querySelector('summary');
    if (summary && summary.getClientRects().length) summary.focus({ preventScroll: true });
    event.preventDefault();
  });
  mobile.addEventListener('change', function () {
    if (!mobile.matches) document.querySelectorAll(selector + '[open]').forEach(close);
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) document.querySelectorAll(selector + '[open]').forEach(close);
    init();
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
